import { makeStyles } from '@material-ui/core';
import { backgroundColorLogin } from 'app/utils/coresUtil';

export const ModalWelcome = makeStyles(() => ({
  container: {
    backgroundColor: backgroundColorLogin,
    justifyContent: 'center',
    alignItems: 'center',
    display: 'flex',
    flexDirection: 'column',
    flex: '1 1 auto',
  },
  card: {
    maxWidth: '60%',
  },
  divParagrafo: {
    marginTop: '60px',
    marginBottom: '30px',
  },
  paragrafo: {
    fontSize: '22px',
    lineHeight: '1.9',
  },
  actions: {
    padding: '20px',
  },
  primeiraImagem: {
    marginTop: '30px',
    marginRight: '30px',
    width: '600px',
    height: '270px',
  },
  segundaImagem: {
    marginTop: '30px',
    marginRight: '60px',
    width: '300px',
    height: '300px',
  },
  botaoAvancar: {
    fontWeight: 'bold',
    background: '#5890AA',
    color: 'white',
    '&:hover': {
      background: '#305F74',
      color: 'white',
    },
    margin: '0px 50px 30px 50px',
  },
}));
